/* import __COLOCATED_TEMPLATE__ from './channels-oauth-instructions.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { type PulseAccordion } from 'glint/pulse';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type ZendeskConfiguration from 'embercom/models/standalone/zendesk-configuration';
import { tracked } from '@glimmer/tracking';

interface Args {
  accordion: PulseAccordion;
}

interface Signature {
  Args: Args;
}

export default class ChannelsOauthInstructions extends Component<Signature> {
  @service declare finStandaloneService: FinStandaloneService;

  @tracked isComplete = false;

  get zendeskConfig(): ZendeskConfiguration {
    return this.finStandaloneService.zendeskConfig!;
  }

  get sunshineConfig() {
    return this.zendeskConfig.sunshineIntegration;
  }

  get isDisconnected() {
    return !this.sunshineConfig || this.sunshineConfig.isSunshineDisconnected;
  }

  get isIncomplete() {
    return this.isDisconnected || !this.isComplete;
  }

  get zendeskMarketplaceBotsUrl() {
    return `https://${this.zendeskConfig.subdomain}.zendesk.com/admin/ai/ai-agents/ai-agents/marketplace-bots`;
  }

  @action
  onContinue() {
    this.isComplete = true;
    this.args.accordion.accordionAPI.closeSection('sunshine-channels-oauth');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Zendesk::Deploy::Sunshine::ChannelsOauthInstructions': typeof ChannelsOauthInstructions;
    'standalone/zendesk/deploy/sunshine/channels-oauth-instructions': typeof ChannelsOauthInstructions;
  }
}
